import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { CardMedia } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import api from './exhibitApi'
import './FeaturedStory.css'

export default function FeaturedStory({ story }) {
  const {image = '', title = '', description = '', _id=''} = story ?? {}
  const src = api.image().imageUrl(image, 398, 300, window.devicePixelRatio)
  const { url } = useRouteMatch()


  return (
    <Card className='c-feature' elevation={0} square={true} >
      <CardContent>
        <Typography className='c-label'>
          Featured
        </Typography>
        <CardMedia className="c-feature--media">
            <Link to={`${url}/story/${_id}`}>
              <img className="c-feature--media__image" src={ src } alt="" />
              <CardContent className="c-feature--content__wrapper">
                <Typography className="c-feature--title">
                  {title}
                </Typography>
                <Typography className='c-feature--description'>
                  {description}
                </Typography>
              </CardContent>
            </Link>
        </CardMedia >
      </CardContent>
    </Card>
  )
}